import { render, staticRenderFns } from "./paciente.vue?vue&type=template&id=7233b1c7&scoped=true&"
import script from "./paciente.vue?vue&type=script&lang=js&"
export * from "./paciente.vue?vue&type=script&lang=js&"
import style0 from "./paciente.vue?vue&type=style&index=0&id=7233b1c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7233b1c7",
  null
  
)

export default component.exports